@if(isStandardWebsite()) {
<main class="main">
	<div class="header">
		<!-- TODO: Need to implement tooltip on seal & logo-->
		<div class="seal" (click)="goHome()">
			<img alt="Idaho State Treasurer's Office - eBank" src="../assets/images/Logo.png" />
			<div class="appTitle">
				<span>eBank</span>
			</div>
			@if (showMenu()) {
			<ng-container>
				<isto-menu [menuItems]="menuItems()"></isto-menu>
			</ng-container>
			}
		</div>
		@if (showMenu()) {
		<ng-container>
			<div class="profileMenu" [matMenuTriggerFor]="profileMenu">
				<span class="material-symbols-outlined"> person </span>
				<span class="name">{{ loggedInUserName() }}</span>
				<span class="material-symbols-outlined"> arrow_drop_down </span>
				<mat-menu #profileMenu>
					<button mat-menu-item (click)="changeContactInformation()">Change Contact Information</button>
					<!-- <button mat-menu-item (click)="changeEmailPreferences()">
							Change Email Preferences
						</button> -->
					<button mat-menu-item (click)="changePassword()">
						Change Password
					</button>
					<mat-divider></mat-divider>
					<button mat-menu-item (click)="logout()">Logout</button>
				</mat-menu>
			</div>
		</ng-container>
		}
	</div>
</main>
}
<router-outlet />